<template>
  <div class="flex flex-row">
    <SharingPopup v-if="state.sharingPopupIsVisible && props.wall" :wall="props.wall" :user-is-owner="userIsOwner" @close-popup="closePopup" />
    <EditWallPopup
      v-if="state.wallEditPopupIsVisible && userIsOwner && props.wall"
      :wall="props.wall"
      :selected-index="selectedIndex"
      @close-popup="closeWallPopup"
      @set-task-id="(id) => emit('setTaskId', id)"
    />
    <FileExportPopup v-if="state.fileExportPopupIsVisible && props.wall" :wall-id="props.wall._id" @close-popup="closeFileExportPopup()" />
    <div id="menubar" class="h-14 flex items-center pr-3 w-full justify-between text-slate-white bg-slate-black fadein">
      <Logo class="cursor-pointer min-w-32" @click.prevent="navigateToDashboard()" />
      <!--
        <div v-if="false" class="w-1/6 bg-text-fade-bright overflow-hidden rounded ml-7">
        <p class="ml-1 whitespace-nowrap font-black text-xl">{{ props.wall.details.title }}</p>
      </div>
      -->
      <div v-if="!state.noTasksAvailable && props.isAttachedToWall && !isMobileView" class="w-3/4 flex mx-3 justify-between">
        <!--
          <div class="flex w-3/4 justify-center items-center">
            <div v-for="(item, index) in props.wall.tasks" :key="index" class="flex flex-row">
              <p
                v-if="index === selectedIndex.value || index === selectedIndex.value + 1 || index === selectedIndex.value - 1"
                class="whitespace-nowrap text-lg"
                :class="taskStyle(index, props.wall.tasks.length)"
              >
                {{ shortenedTaskTitle(item.title, index) }}
              </p>
              <p v-if="(index === selectedIndex.value || index === selectedIndex.value - 1) && index + 1 < props.wall.tasks.length" class="mx-2">/</p>
            </div>
          </div>
        -->
        <div v-if="props.wall" class="flex w-3/4 justify-center items-center font-bold">
          <h1>{{ props.wall.tasks[selectedIndex].title }}</h1>
        </div>

        <div v-if="props.wall && props.wall.tasks.length > 1" class="flex bg-slate-middle justify-evenly w-16 rounded-3xl py-2">
          <div class="w-fit" tabindex="0" @pointerup="navigateTask(-1)" @keyup.enter="navigateTask(-1)">
            <img class="cursor-pointer w-3 invert" :class="previousTaskBtnStyle" :src="Arrow" :alt="t('aria-navigate-previous')" />
          </div>

          <div class="w-fit" tabindex="0" @pointerup="navigateTask(1)" @keyup.enter="navigateTask(1)">
            <img class="cursor-pointer rotate-180 w-3 invert" :class="nextTaskBtnStyle" :src="Arrow" :alt="t('aria-navigate-next')" />
          </div>
        </div>
      </div>
      <div v-if="props.wall && isMobileView" class="flex flex-grow justify-center items-center font-bold mr-11">
        {{ props.wall.tasks[selectedIndex].title }}
      </div>
      <div class="flex h-11 items-center">
        <div
          v-if="props.isAttachedToWall && !isMobileView && false"
          class="rounded-full p-2 bg-slate-middle h-9 w-9 flex items-center justify-center mr-2 cursor-pointer"
          @pointerup="setFileExportPopupIsVisible()"
          @keyup.enter="setFileExportPopupIsVisible()"
        >
          <img :src="FileIcon" class="w-3.5 invert" :alt="t('aria-file-export')" />
        </div>

        <div
          v-if="props.isAttachedToWall && !isMobileView"
          class="rounded-full p-2 bg-slate-middle h-9 w-9 flex items-center justify-center mr-2 cursor-pointer"
          tabindex="0"
          @pointerup="setPinPopupIsVisible()"
          @keyup.enter="setPinPopupIsVisible()"
        >
          <img :src="TagIcon" class="w-4 invert" :alt="t('aria-info-options')" />
        </div>
        <ShowPinPopup v-if="state.pinPopupIsVisible && props.wall" class="mt-4" :wall="props.wall" @close-popup="hidePinPopup()" />
        <div
          v-if="userIsOwner && props.isAttachedToWall && !isMobileView"
          class="rounded-full p-2 bg-slate-middle h-9 w-9 flex items-center justify-center mr-2 cursor-pointer"
          tabindex="0"
          @pointerup="setWallEditPopupIsVisible()"
          @keyup.enter="setWallEditPopupIsVisible()"
        >
          <img :src="EditIcon" class="w-3.5 invert" :alt="t('aria-wall-options')" />
        </div>
        <div
          v-if="props.isAttachedToWall && !isMobileView && userIsOwner"
          tabindex="0"
          class="rounded-full p-2 bg-slate-middle h-9 w-9 flex items-center justify-center mr-2 cursor-pointer"
          @pointerup="setSharingPopupIsVisible()"
          @keyup.enter="setSharingPopupIsVisible()"
        >
          <img :src="ShareIcon" class="w-3.5 invert" :alt="t('aria-sharing-options')" />
        </div>
        <Notifications v-if="userIsOwner" />

        <button
          v-if="!props.isAttachedToWall"
          @click="openLink('https://nettskjema.no/a/samtavla-tilbakemelding')"
          class="flex flex-row m-1 mr-28 font-alexandria border-4 border-tw-blue-dark rounded-full items-center self-start cursor-pointer shadow-lg whitespace-nowrap"
        >
          <span class="px-6 text-sm">{{ t('sendUsYourFeedback') }}</span>
          <div class="bg-tw-blue-dark rounded-full size-7 flex flex-row items-center justify-center">
            <img class="w-4" :src="rightArrow" alt="right arrow" />
          </div>
        </button>
        <div class="min-w-16 mx-4">
          <LanguageOption />
        </div>
        <div class="relative rounded-full h-9 w-9 bg-slate-middle flex items-center justify-center cursor-pointer">
          <div
            class="rounded-full p-2 h-9 w-9 flex items-center justify-center"
            tabindex="0"
            @pointerup.stop="toggleMenuSidebar()"
            @keydown.enter="toggleMenuSidebar()"
          >
            <img v-if="!state.menuSidebarIsVisible" :src="MenuIcon" class="w-3 invert" :alt="t('aria-main-menu')" />
            <img v-else class="w-5 invert rotate-45" :src="Plus" :alt="t('aria-close')" />
          </div>
          <!-- Desktop menu -->
          <MenuBarOptions
            v-if="state.menuSidebarIsVisible && common.getters.screensizeType.value === ScreensizeType.desktop"
            class="absolute top-0 right-0 z-101"
            @toggle-main-menu="toggleMenuSidebar()"
          >
            <button
              v-if="props.isAttachedToWall && isRegistered"
              class="bg-slate-middle rounded-xl cursor-pointer"
              @pointerup="setFileExportPopupIsVisible()"
              @keydown.enter="setFileExportPopupIsVisible()"
            >
              {{ t('export') }}
            </button>
          </MenuBarOptions>
        </div>
      </div>

      <!-- Mobile device menu -->
      <div
        v-if="state.menuSidebarIsVisible && common.getters.screensizeType.value !== ScreensizeType.desktop"
        class="absolute md:w-1/2 w-full right-0 bg-slate-black menusidebar h-full top-14 fadein flex flex-col justify-between xl:justify-start overflow-auto overflow-x-hidden"
        :style="menuStyles"
      >
        <div>
          <div v-if="props.isAttachedToWall && isMobileView && props.wall" class="flex p-3 m-5 bg-slate-middle rounded-xl overflow-hidden">
            <p class="whitespace-nowrap text-3xl font-bold text-center w-full">{{ props.wall.details.title }}</p>
          </div>
          <div
            v-if="props.isAttachedToWall && isMobileView"
            class="flex p-3 m-5 bg-slate-middle rounded-xl flex-col justify-center cursor-pointer items-center overflow-hidden"
          >
            <div class="flex justify-center flex-col items-center w-full">
              <div class="flex w-full mb-4">
                <p class="whitespace-nowrap text-xl font-bold mt-1">{{ t('tasks') }}</p>
              </div>
              <div
                v-if="props.wall"
                class="flex w-full justify-center items-center overflow-auto overflow-x-hidden max-h-56"
                :class="mobileTaskWrapperStyle"
              >
                <div
                  v-for="(item, index) in props.wall.tasks"
                  :key="index"
                  class="flex flex-row"
                  :class="mobileTaskStyles(index, props.wall.tasks.length)"
                >
                  <p class="text-2xl md:text-xl" :class="taskStyle(index, props.wall.tasks.length)">
                    {{ shortenedTaskTitle(item.title, index) }}
                  </p>
                </div>
              </div>
              <div v-if="props.wall && isMobileView" class="task-text-wrapper flex justify-evenly rounded-xl mt-5 w-full">
                <div
                  v-if="props.wall.tasks.length > 1"
                  class="bg-slate-dark flex justify-center items-center w-1/2 p-2 mr-2 rounded-3xl"
                  @click="navigateTask(-1)"
                  @touchstart.prevent="navigateTask(-1)"
                >
                  <img class="cursor-pointer w-5 mr-3 invert" :class="previousTaskBtnStyle" :src="Arrow" :alt="t('aria-navigate-previous')" />
                </div>
                <div
                  v-if="props.wall.tasks.length > 1"
                  class="bg-slate-dark flex justify-center items-center w-1/2 p-2 ml-2 rounded-3xl"
                  @click="navigateTask(1)"
                  @touchstart.prevent="navigateTask(1)"
                >
                  <img class="rotate-180 w-5 cursor-pointer invert" :class="nextTaskBtnStyle" :src="Arrow" :alt="t('aria-navigate-next')" />
                </div>
              </div>
              <div v-else-if="props.wall" class="task-text-wrapper flex bg-slate-dark justify-evenly rounded-xl py-4 mt-2">
                <img
                  v-if="props.wall.tasks.length > 1"
                  class="cursor-pointer w-4 mr-3 invert"
                  :class="previousTaskBtnStyle"
                  :src="Arrow"
                  @click="navigateTask(-1)"
                  @touchstart.prevent="navigateTask(-1)"
                  :alt="t('aria-navigate-previous')"
                />
                <img
                  v-if="props.wall.tasks.length > 1"
                  class="rotate-180 w-4 cursor-pointer invert"
                  :class="nextTaskBtnStyle"
                  :src="Arrow"
                  @click="navigateTask(1)"
                  @touchstart.prevent="navigateTask(1)"
                  :alt="t('aria-navigate-next')"
                />
              </div>
            </div>
          </div>
        </div>
        <div>
          <div v-if="props.isAttachedToWall && isMobileView" class="h-px bg-slate-bright mx-7"></div>
          <div v-if="props.isAttachedToWall" class="flex m-5 justify-between flex-col">
            <div class="flex mb-2">
              <div
                v-if="userIsOwner && props.isAttachedToWall && isMobileView"
                class="flex justify-center items-center w-1/2 bg-slate-middle rounded-xl p-4 mr-2 cursor-pointer"
                @click="setWallEditPopupIsVisible()"
                @touchstart.prevent="setWallEditPopupIsVisible()"
              >
                <div class="rounded-full p-2 bg-slate-bright h-14 w-14 flex items-center justify-center mr-2">
                  <img :src="EditIcon" class="w-7 p-1 invert" :alt="t('aria-wall-options')" />
                </div>
              </div>
              <div
                v-if="props.isAttachedToWall && isMobileView && userIsOwner"
                class="flex justify-center items-center w-1/2 bg-slate-middle rounded-xl p-4 cursor-pointer"
                @pointerup.stop="setSharingPopupIsVisible()"
              >
                <div class="rounded-full p-2 bg-slate-bright h-14 w-14 flex items-center justify-center mr-2">
                  <img :src="ShareIcon" class="w-8 p-1 invert" :alt="t('aria-sharing-options')" />
                </div>
              </div>
              <div
                v-if="props.isAttachedToWall && !userIsOwner"
                class="flex justify-center items-center w-full bg-slate-middle rounded-xl p-9 cursor-pointer"
                @pointerup.stop="setPinPopupIsVisible()"
              >
                <div class="rounded-full p-2 bg-slate-bright h-14 w-14 flex items-center justify-center mr-2">
                  <img :src="TagIcon" class="w-8 p-1 invert" :alt="t('aria-info-options')" />
                </div>
              </div>
            </div>

            <div
              v-if="props.isAttachedToWall && isRegistered"
              class="flex justify-center items-center w-full bg-slate-middle rounded-xl p-4 cursor-pointer"
              @click="setFileExportPopupIsVisible()"
            >
              <div class="rounded-full p-2 bg-slate-bright h-14 w-14 flex items-center justify-center mr-2">
                <img :src="FileIcon" class="w-8 p-1 invert" :alt="t('aria-file-export')" />
              </div>
            </div>
          </div>
        </div>
        <div v-if="isMobileView" class="h-px bg-slate-bright mx-7"></div>
        <div class="flex xl:m-0 flex-col xl:flex-wrap justify-evenly relative xl:absolute bottom-3 w-full">
          <div class="w-full flex justify-between px-5 xl:flex-col">
            <div class="flex justify-center w-1/2 items-center bg-slate-middle rounded-xl p-3 xl:w-full mr-1 xl:mx-0 xl:my-1">
              <LandingpageOption class="text-lg font-bold" />
            </div>
            <div
              v-if="props.isAttachedToWall && isRegistered"
              class="flex justify-center items-center w-1/2 bg-slate-middle rounded-xl p-3 xl:w-full ml-1 xl:m-0"
            >
              <DashboardOption class="text-lg font-bold" />
            </div>
          </div>
          <div class="w-full flex my-2 xl:mt-0 xl:mb-2 px-5 xl:flex-col">
            <div class="regular-btn flex justify-center items-center w-1/2 bg-slate-middle rounded-xl p-9 xl:w-full mr-1 xl:mx-0 xl:my-1">
              <LanguageOption class="text-lg font-bold" />
            </div>
            <div class="flex justify-center items-center bg-slate-middle rounded-xl p-9 w-1/2 xl:w-full xl:m-0 ml-1" :class="logoutStyles">
              <LogoutOption class="text-lg font-bold" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
  import { reactive, computed, onBeforeMount, watch, nextTick, onMounted, PropType } from 'vue'
  import { useRouter } from 'vue-router'
  import { useI18n } from 'vue-i18n'

  import { StoreResponse } from '@/common/interfaces'
  import { Wall, User, Task, Parcel, DialogMessageType } from '@/common/classes'
  import { ParcelType, PermissionLevel, ScreensizeType } from '@/constants'

  import { useUserStore } from '@/composables/userStore'
  import useWallStore from '@/composables/wallStore'

  import useDialogStore from '@/composables/dialog'
  import useParcelStore from '@/composables/parcel'
  import useColorStore from '@/composables/colors'
  import useFilterStore from '@/composables/filter'
  import useCommonStore from '@/composables/common'

  import SharingPopup from '../popups/SharingPopup.vue'
  import EditWallPopup from '../popups/EditWallPopup.vue'
  import FileExportPopup from '../popups/FileExportPopup.vue'

  import Logo from '../navigation/LogoView.vue'
  import MenuBarOptions from './MenuBarOptions.vue'
  import Notifications from '@/components/common/NotificationsView.vue'
  import LandingpageOption from './LandingpageOption.vue'
  import DashboardOption from './DashboardOption.vue'
  import LanguageOption from './LanguageOption.vue'
  import LogoutOption from './LogoutOption.vue'

  import FileIcon from '../../assets/icons/fontawesome/download-solid.svg'
  import ShareIcon from '../../assets/icons/fontawesome/share-nodes-solid.svg'
  import MenuIcon from '../../assets/icons/fontawesome/bars-solid.svg'
  import Arrow from '../../assets/icons/fontawesome/angle-left-solid.svg'
  import EditIcon from '../../assets/icons/fontawesome/pen-solid.svg'
  import TagIcon from '../../assets/icons/fontawesome/circle-info-solid-2.svg'
  import ShowPinPopup from '../popups/ShowPinPopup.vue'
  import Plus from '@/assets/icons/fontawesome/plus-solid.svg'
  import rightArrow from '@/assets/icons/rightArrowWhite.svg'

  const userStore = useUserStore()
  const wallStore = useWallStore()
  const parcelStore = useParcelStore()
  const dialogStore = useDialogStore()
  const color = useColorStore()
  const filter = useFilterStore()
  const router = useRouter()
  const common = useCommonStore()

  const { isMobileView } = common.getters

  const { t } = useI18n()

  const props = defineProps({
    wall: { type: Object as PropType<Wall> | undefined, default: undefined },
    isAttachedToWall: { type: Boolean, required: true },
  })

  const emit = defineEmits<{
    (e: 'setTaskId', id: string): void
  }>()

  const state = reactive({
    user: {} as User,

    fileExportPopupIsVisible: false,
    wallEditPopupIsVisible: false,
    sharingPopupIsVisible: false,
    pinPopupIsVisible: false,

    menuSidebarIsVisible: false,
    noTasksAvailable: false,
    attachedToWall: false,
  })

  const selectedIndex = computed(() => {
    const index = props.wall?.tasks.findIndex((t) => t._id == filter.getters.selectedTaskId.value) ?? 0
    return index > -1 ? index : 0
  })

  const openLink = (url: string) => {
    window.open(url, '_blank', 'noopener,noreferrer')
  }

  onMounted(() => {
    setTimeout(() => {
      nextTick(() => {
        if (props.wall && userStore.getters.user.value) {
          if (!common.getters.isMobileView.value && userStore.getters.user.value._id === props.wall.users.owner.user_id) setPinPopupIsVisible()
        }
      })
    }, 500)
  })

  onBeforeMount(() => {
    const user = userStore.getters.user.value
    if (user) state.user = user
    if (props.wall && props.isAttachedToWall) {
      if (props.wall.tasks === undefined) state.noTasksAvailable = true
    } else state.noTasksAvailable = true
  })

  const userIsOwner = computed(() => {
    try {
      const user = userStore.getters.user.value
      if (user) {
        return common.actions.hasMinimumPermission(user, PermissionLevel.Organize, props.wall)
      } else return false
    } catch (e) {
      return false
    }
  })

  const mobileTaskWrapperStyle = computed(() => {
    return isMobileView.value ? 'flex flex-col' : ''
  })

  function mobileTaskStyles(index: number, length: number) {
    const firstCorrection = index === 0 && length > 3 ? '34' : ''
    return `${firstCorrection} ${isMobileView ? 'bg-slate-dark w-full p-2 rounded-2xl mb-2' : ''}`
  }

  const menuStyles = computed(() => {
    switch (common.getters.screensizeType.value) {
      case ScreensizeType.desktop:
        return 'z-index: 60; height: calc(100% - 56px);'
      case ScreensizeType.tablet:
        return 'z-index: 60; height: calc(100% - 56px);'
      default:
        return 'z-index: 151; height: calc(100% - 56px);'
    }
  })

  const isRegistered = computed(() => {
    const user = userStore.getters.user.value
    return user ? user.status.isRegistered : false
  })

  const logoutStyles = computed(() => {
    return props.isAttachedToWall ? 'w-1/2' : 'w-full'
  })

  const previousTaskBtnStyle = computed(() => {
    return selectedIndex.value === 0 ? 'opacity-50' : 'opacity-100'
  })

  const nextTaskBtnStyle = computed(() => {
    if (props.wall) {
      return props.wall.tasks.length === selectedIndex.value + 1 ? 'opacity-50' : 'opacity-100'
    } else return ''
  })

  const hasTaskNavigationPermission = computed(() => {
    const user = userStore.getters.user.value
    if (props.wall && user) {
      return (
        [PermissionLevel.Owner, PermissionLevel.Organize].some((p: PermissionLevel) => p === wallStore.actions.getPermissionLevelForUser(user)) ||
        props.wall.users.owner.user_id === user._id
      )
    } else return false
  })

  async function navigateTask(difference: number) {
    const user = userStore.getters.user.value
    if (props.wall && user) {
      let newIndex = selectedIndex.value + difference
      if (newIndex > -1 && newIndex < props.wall.tasks.length) {
        emit('setTaskId', props.wall.tasks[newIndex]._id)

        if (hasTaskNavigationPermission.value) {
          // only owners or organisers should be allowed to send the parcel
          const parcel = new Parcel({ parcelType: ParcelType.TaskMove, body: props.wall.tasks[newIndex]._id }, user, props.wall)
          await parcelStore.actions.sendParcel(props.wall._id, parcel)
        }
      }
      if (common.getters.isMobileView) state.menuSidebarIsVisible = false
    }
  }

  /**
   * lockWall()
   * NOTE: currently not used in the menubar, keeping it for future versions
   */
  function lockWall() {
    if (props.wall) {
      const lockedWall = new Wall(props.wall)
      lockedWall.status.readOnly = !lockedWall.status.readOnly
      wallStore.actions.updateWall(lockedWall).then((res: StoreResponse) => {
        if (res.success) dialogStore.actions.pushMessage('', DialogMessageType.Warning, t('lockedwall'))
      })
    }
  }

  function toggleMenuSidebar() {
    state.menuSidebarIsVisible = !state.menuSidebarIsVisible
  }

  function navigateToDashboard() {
    if (isRegistered.value) router.push('/dashboard')
  }

  function taskStyle(index: number, length?: number) {
    const mobileStyle = isMobileView ? 'whitespace-nowrap ' : ' '
    const styles =
      index === 0 && length === 1 // single tasks should also be faded out if the length is 1
        ? 'font-bold bg-text-fade-bright'
        : index !== selectedIndex.value
          ? 'text-slate-bright bg-text-fade'
          : 'text-slate-white font-bold'
    return mobileStyle + styles
  }

  function shortenedTaskTitle(title: string, index: number) {
    const length = index !== selectedIndex.value ? 14 : 26
    return title.length < 15 ? title : title.substring(0, length)
  }

  function setWallEditPopupIsVisible() {
    state.wallEditPopupIsVisible = true
    state.menuSidebarIsVisible = false
  }

  function setPinPopupIsVisible() {
    state.pinPopupIsVisible = !state.pinPopupIsVisible
    state.menuSidebarIsVisible = false
  }

  function hidePinPopup() {
    state.pinPopupIsVisible = false
  }

  function setSharingPopupIsVisible() {
    state.sharingPopupIsVisible = true
    state.menuSidebarIsVisible = false
  }

  function setFileExportPopupIsVisible() {
    state.fileExportPopupIsVisible = true
    state.menuSidebarIsVisible = false
  }

  //Updated closedWallPopup function that handles stale walls after editing a wall
  function closeWallPopup(selectedTaskPosition: number, persist: boolean) {
    const updatedWall = wallStore.getters.selectedWall.value //Get updated wall state from wallStore instead of props
    state.wallEditPopupIsVisible = false

    if (persist && updatedWall && updatedWall.tasks[selectedTaskPosition]) {
      emit('setTaskId', updatedWall.tasks[selectedTaskPosition]._id)
    }
  }

  function closeFileExportPopup() {
    state.fileExportPopupIsVisible = false
  }

  function closePopup() {
    state.sharingPopupIsVisible = false
  }
</script>

<style scoped></style>
